var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNairaSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M424 264H384V56C384 42.75 373.25 32 360 32S336 42.75 336 56V264H258.461L107.844 42.5C101.906 33.781 91.062 29.969 80.938 33.062C70.875 36.156 64 45.469 64 56V264H24C10.75 264 0 274.75 0 288S10.75 312 24 312H64V456C64 469.25 74.75 480 88 480S112 469.25 112 456V312H233.059L340.156 469.5C344.719 476.188 352.219 480 360 480C362.344 480 364.719 479.656 367.062 478.938C377.125 475.844 384 466.531 384 456V312H424C437.25 312 448 301.25 448 288S437.25 264 424 264ZM112 264V133.969L200.42 264H112ZM336 378.031L291.1 312H336V378.031Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNairaSign);
export default __webpack_public_path__ + "static/media/naira-sign.2ce97294359e796255537cfeeda49fec.svg";
export { ForwardRef as ReactComponent };